import React, { useState,useEffect,useRef } from "react";
import './classes/EditAgentProfile.css';
import Editor from 'react-simple-wysiwyg';
import { configData } from "../config";
import { useNavigate,useLocation  } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Loading from './Loading';
import Link from '@mui/material/Link';
import EditAthlete from "./EditAthlete";
import EditMentorProfile from "./EditMentorProfile";

const ViewMentorProfile = ({uid,username,userLoggedInRoles,userDetails}) => {

    const [activeView, setActiveView] = useState("view");
     const showView = () => {
        const newView = activeView === "view" ? "edit_mentor" : "mentor";
        setActiveView(newView);
    
        navigate(`/user/${uid}/${newView}`);
      };
    
    const location = useLocation();
    
    useEffect(() => {
      if (location.pathname.includes("/edit_mentor")) {
        setActiveView("edit");
      } else {
        setActiveView("view");
      }
    }, [location.pathname]); 
    const successMentorEditMessage = location.state?.result; 
  
const [successEditMessage, setSuccessEditMessage] = useState('');

        useEffect(() => {
          if (successMentorEditMessage) {
            setSuccessEditMessage(successMentorEditMessage);
            getmentordetails();
            window.history.replaceState({}, '');
          }
        }, [successEditMessage, location.state]);

    const [toggles, setToggles] = useState({
        MentorMainDetails: true,
        mentorDetails: true,
        MentorBio: true,
        mentorPlacements: true,
    });

    const handleToggle = (key) => {
        setToggles((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };
    

    const navigate = useNavigate();
    const app_url = configData.APP_URL;

 
    const [agentuploadFiles, setAgentUploadedFiles] = useState([]);

    const [athleteSportList, setAthleteSportList] = useState('');
    const [allAthletes, setAthleteList] = useState([]);
    const [assignedAthletes, setAssignedAthleteList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const loggedin_uid = localStorage.getItem('drupal_uid');
    const [mentorassests, setmentorassests] = useState([]);
    const [socialAssets, setSocialAssets] = useState({});
    const [commonAssets, setCommonAssets] = useState({});

const athleteSportField = mentorassests?.find(
  (item) => item.key === "field_athlete_sports"
);

const athleteSportlist = athleteSportField?.full_value
  ? athleteSportField.full_value.split(",")
  : [];
const transformData = (dataArray) => {
        if (!dataArray) return {};
        return dataArray.reduce((acc, item) => {
            // Handle date/time objects or standard values
            acc[item.key] = item.full_value ?? item.value ?? null;
            return acc;
        }, {});
    };

    const mentorData = transformData(mentorassests);



const sections = [
        {
            key: "field_mentor_biography",
            keyToggle: "MentorBio",
            title: "Mentor Biography",
            emptyText: "No biography content available.",
            customClass: "bio-style"
        },
 
];

const rightSectionFields = [
  { label: "Mentor Sort Order", key: "field_mentor_sort_order" },
];

// Parse the placements and filter out any empty selections
const rawPlacements = mentorData.field_mentor_placements;
let placementsArray = [];

try {
    const parsed = typeof rawPlacements === 'string' ? JSON.parse(rawPlacements) : (rawPlacements || []);
    // ONLY show rows where a page ID is actually present
    placementsArray = Array.isArray(parsed) ? parsed.filter(p => p.page && p.page !== "") : [];
} catch (e) {
    console.error("Error parsing placements:", e);
    placementsArray = [];
}
   
    
    const getCurrentDateFormatted = () => {
        const today = new Date();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const yyyy = today.getFullYear();
        return `${yyyy}-${mm}-${dd}`;
    };
    const currentFormattedDate = getCurrentDateFormatted();

    const getCurrentBDateFormatted = () => {
        const today = new Date();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const yyyy = today.getFullYear();
        return `${mm}/${dd}/${yyyy}`;
    };
    const currentFormattedBDate = getCurrentBDateFormatted();  
    
const parseDate = (dateString) => {
    if (!dateString) return null;

    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
        const [mm, dd, yyyy] = dateString.split('/');
        dateString = `${yyyy}-${mm}-${dd}`;
    }
    const dateObj = new Date(dateString);
    return isNaN(dateObj) ? null : dateObj;
};

useEffect(() => {
  const fetchData = async () => {
    try {
      await Promise.all([
        getmentordetails(),
        // getfieldslist()
      ]);
    } catch (err) {
      console.error(err);
    }
  };

  fetchData();
}, []);
 
async function getmentordetails() { 
  if (uid !== '' || username !== '') {
    try {
      setIsLoading(true);

      const response = await fetch(
        app_url + 'viewprofile/getmentordetails?uid=' + uid
      );

      const responsedata = await response.json();

      if (responsedata.data.result === "Success") {
        setmentorassests(responsedata.data.user_mentor_assets || []);
      }

    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsLoading(false);
    }
  }
}

// async function getfieldslist() {
    
//          try {
//             const response = await fetch(
//                 app_url+'smwwfieldlist/getfieldlist',
//                 {
//                     method: "GET",
  
//                     headers: {
//                         'Content-Type': 'application/json',
//                     },
//                 }
//             )
//             const responsedata = await response.json();
//             if(responsedata.data) {
            
//                setAthleteType(responsedata.data.athletetype);
//             } 
//         } catch (err) {
            
//          }
        
//   }
 
// const getAthleteTypeLabel = (id) => {
//     // athletesportList is the state variable where you stored the response.data.athletetype
//     if (athleteType && athleteType[id]) {
//         return athleteType[id];
//     }
//     return id; // Fallback to the ID if the label isn't found
// };


    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (        
                 <>
                    {activeView === "view" ? (<>
                            <div className='viewtab-top-section'>
                                  {successEditMessage && (
                                <div className="set-message-done" style={{marginBottom: "5px"}}>
                                    <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span>&nbsp;
                                    {/* {successEditMessage} */}
                                    <span
                                        dangerouslySetInnerHTML={{ __html: successEditMessage }}
                                    />
                                </div>
                                )}
                                <div>
                                    <div className="edit-agent-prof-editbtn">
                                        <button class="main-app-action-btn edit-fields-btn" onClick={showView}>✎ Edit</button>
                                    </div>
                                    <div 
                                    className={`view-user-profile-section-header agent-section-header ${toggles["MentorMainDetails"] ? "open" : ""}`}
                                    style={{border: "0px", outline: "1px solid #bbb"}}
                                    >
                                        <div class="app-aspect-content" onClick={() => handleToggle("MentorMainDetails")}>
                                            <div class="aspect-info">
                                                <span class="view-user-profile-section-heading"><strong>Mentor Profile</strong></span>
                                            </div>
                                        </div>
                                        {toggles.MentorMainDetails && (
                                            <div class="view-user-profile-section-body-container">
                                                <div class="view-user-profile-section-container user-profile-summary-table user-profile-details user-contact-info">

                                                    <div className="edit-agent-prof-details" style={{justifyContent: "flex-start"}}>
                                                        <div style={{flexShrink: "0"}}>
                                                            <div class="edit-agent-image">
                                                                {mentorData.field_mentor_photo ? (  
                                                                    <><img  src={mentorData.field_mentor_photo} width="100px" height="100px" alt = "user"/></>
                                                                ):(
                                                                    <div className="edit-agent-img-placeholder">No Photo<br />Uploaded</div>
                                                                )}
                                                            </div>
                                                            <div className="agent-img-desc">100–1000px · png/jpg/gif</div>
                                                        </div>
                                                
                                                        <div class="agent-name-loc" style={{marginBottom:'2%', minWidth: "200px", maxWidth: "495px"}}>
                                                            <div class="user-name" style={{color:"#333333"}} >{userDetails.first_name} {userDetails.last_name}</div>
                                                            <div class="user-loc" style={{marginBottom:"15px",fontSize:"13px",color:"#666666"}}>{userDetails.city && userDetails.city+', '} 
                                                            {userDetails.state && userDetails.state+', '} {userDetails.country && userDetails.country}</div>
                                                            <div class="user-loc" style={{marginBottom:"5px",fontSize:"12px",fontWeight:"700",color:"#666666"}}>Mentor Sports</div>
                                                            {/* {sportList.length > 0 ? (
                                                                <span className='profile-applied-course-tag-row' style={{padding: "0px", marginBottom: "15px"}}>
                                                                {sportList.map((item, index) => {
                                                                    return <><span className='profile-applied-course-tags'>{item['value']}</span></>
                                                                })}  
                                                                </span>
                                                            ) : (                                                            
                                                                <span className='profile-applied-course-tag-row' style={{padding: "0px", marginBottom: "15px"}}>
                                                                    <span className='profile-applied-course-tags' style={{color: "#999", fontStyle: "italic"}}>None selected</span>
                                                                </span>
                                                            )} */}
                                                           <span
                                                            className="profile-applied-course-tag-row"
                                                            style={{ padding: "0px", marginBottom: "15px" }}
                                                            >
                                                            {mentorData.field_mentor_sports ? (
                                                                mentorData.field_mentor_sports.split(',').map((sport, i) => (
                                                                    <span key={i} className="profile-applied-course-tags">{sport.trim()}</span>
                                                                ))
                                                            ) : (
                                                                <span className="profile-applied-course-tags" style={{ color: "#999" }}>None Selected</span>
                                                            )}
                                                            </span>
                                                                
                                                           
                                                              
                                                        </div>
{/* <div className="agent-profile-right">
  {rightSectionFields.map((item) => {
    let value = mentorData?.[item.key];



    if (item.key === "field_mentor_sort_order") {
      value = `${mentorData.field_mentor_sort_order}`;
    }

    return (
      <div className="agent-profile-right-content" key={item.key}>
        <div className="agent-profile-right-content-label">
          {item.label}
        </div>
        <div className="agent-profile-right-content-value">
          {value || "-"}
        </div>
      </div>
    );
  })}
</div> */}

                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div style={{clear: "both"}}></div>
                                </div>
                            </div>

{/* <div className={`view-user-profile-section-header ${toggles["AgentJobTitle"] ? "open" : ""}`}>
    <div class="app-aspect-content" onClick={() => handleToggle("AgentJobTitle")}>
        <div class="aspect-info">
            <span class="view-user-profile-section-heading"><strong>Job Title</strong></span>
        </div>
    </div>
    {toggles.AgentJobTitle && (
        <div class="view-user-profile-section-body-container">
            <div class="opinion-header profile_summary view-agent-profile-section-content">
                <div className="agent-richtext-placeholder empty">No job title set.</div>
            </div>
        </div>
    )}
</div> */}

<div className={`view-user-profile-section-header ${toggles["mentorDetails"] ? "open" : ""}`}>
    
    <div className="app-aspect-content" onClick={() => handleToggle("mentorDetails")}>
        <div className="aspect-info">
            <span className="view-user-profile-section-heading">
                <strong>Mentor Details</strong>
            </span>
        </div>
    </div>

    {toggles.mentorDetails && (
        <div className="view-user-profile-section-body-container">
            <div className="profile_summary_sentiment-wrapper view-user-profile-section-container">
                <div className="opinion-header profile_summary view-user-profile-section-content">

                    <table className="user-profile-summary-table">
                        <tbody>

                             {[
                                                            
                                                            ["field_mentor_title", "Mentor Title"],
                                                            ["field_mentor_sort_order", "Mentor Sort Order"],
                                                            ["field_mentor_region", "Mentor Region"],
                                                        ].map(([key, label]) => {
                                                            const val = mentorData[key];
                                                            if (val === null || val === undefined) return null;
                                                            return (
                                                                <tr key={key}>
                                                                    <td className="user-profile-summary-row" valign="top">
                                                                        <span className="user-profile-label">{label}:&nbsp;</span>
                                                                    </td>
                                                                    <td className="user-profile-summary-row" valign="top">
                                                                        <span className="user-profile-value">{val || "-"}</span>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}

                          

                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    )}
</div>
{sections.map((section) => {
//   const content = backEndData?.[section.key];
const content = mentorData?.[section.key];

  return (
    <div
      key={section.keyToggle}
      className={`view-user-profile-section-header ${
        toggles[section.keyToggle] ? "open" : ""
      }`}
    >
      <div
        className="app-aspect-content"
        onClick={() => handleToggle(section.keyToggle)}
      >
        <div className="aspect-info">
          <span className="view-user-profile-section-heading">
            <strong>{section.title}</strong>
          </span>
        </div>
      </div>

      {toggles[section.keyToggle] && (
        <div className="view-user-profile-section-body-container">
          <div
            className={`opinion-header profile_summary view-agent-profile-section-content ${
              section.customClass || ""
            }`}
          >
            {content ? (
              <div
                // className="agent-richtext-placeholder"
                className="agent-richtext-placeholder"
                dangerouslySetInnerHTML={{ __html: content }}
              />
            ) : (
              <div className="agent-richtext-placeholder empty">
                {section.emptyText}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
})}

<div className={`view-user-profile-section-header ${toggles["mentorPlacements"] ? "open" : ""}`}>
    <div className="app-aspect-content" onClick={() => handleToggle("mentorPlacements")}>
        <div className="aspect-info">
            <span className="view-user-profile-section-heading">
                <strong>Mentor Placements</strong>
            </span>
        </div>
    </div>

    {toggles.mentorPlacements && (
        <div className="view-user-profile-section-body-container">
            <div className="view-user-profile-section-container" style={{ padding: '15px' }}>
                {placementsArray.length > 0 ? (
                    <div className="editprofile-fieldset-wrapper" style={{ overflowX: 'auto' }}>
                        <table className="user-profile-summary-table">
                            <thead>
                                <tr style={{ borderBottom: '2px solid #eee', textAlign: 'left' }}>
                                    <th style={{ padding: '10px' }}>Assigned Page</th>
                                    <th style={{ padding: '10px' }}>Display Order</th>
                                </tr>
                            </thead>
                            <tbody>
                                {placementsArray.map((p, index) => (
                                    <tr key={index} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                        <td className="user-profile-summary-row" style={{ padding: '10px' }}>
                                            <span className="user-profile-value">
                                                {/* Logic to show Page Title instead of ID if available */}
                                                {p.page} 
                                            </span>
                                        </td>
                                        <td className="user-profile-summary-row" style={{ padding: '10px' }}>
                                            <span className="user-profile-value">{p.order || "0"}</span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div className="agent-richtext-placeholder empty" style={{ textAlign: 'center', color: '#888' }}>
                        <i className="fa fa-exclamation-circle"></i> No specific page placements have been selected for this mentor.
                    </div>
                )}
            </div>
        </div>
    )}
</div>



{/* {sections.map((section) => {
    const content = backEndData?.[section.key]; //  dynamic backend binding

    return (
        <div
        key={section.keyToggle}
        className={`view-user-profile-section-header ${
            toggles[section.keyToggle] ? "open" : ""
        }`}
        >
            <div
                className="app-aspect-content"
                onClick={() => handleToggle(section.keyToggle)}
            >
                <div className="aspect-info">
                    <span className="view-user-profile-section-heading">
                        <strong>{section.title}</strong>
                    </span>
                </div>
            </div>

            {toggles[section.keyToggle] && (
                <div className="view-user-profile-section-body-container">
                    <div className="opinion-header profile_summary view-agent-profile-section-content">
                        
                        {content ? (
                            <div className="agent-richtext-placeholder" dangerouslySetInnerHTML={{ __html: content }} />
                        ) : (
                            <div className="agent-richtext-placeholder empty">
                                {section.emptyText}
                            </div>
                        )}

                    </div>
                </div>
            )}
        </div>
    );
})} */}
 </>) : (
      <EditMentorProfile uid={uid} userLoggedInRoles={userLoggedInRoles} userMentorAssets={mentorassests}/>
      
      )}
</>
        )}
        </>
    );
};

export default ViewMentorProfile;